// src/components/icons/PhoneInOutIcon.tsx
import * as React from "react";

type Props = React.SVGProps<SVGSVGElement> & {
  size?: number | string;
  strokeWidth?: number | string;
  title?: string;
  arrowOffsetX?: number;
  arrowOffsetY?: number;
  arrowGap?: number;
  arrowHeadSize?: number;
};

export default function PhoneInOutIcon({
  size = 24,
  strokeWidth = 2,
  title,
  arrowOffsetX = 2.25,
  arrowOffsetY = -1.25,
  arrowGap = 7.5,   
  arrowHeadSize = 3,
  ...props
}: Props) {
  const midY = 8.5;
  const yTop = midY - arrowGap / 2;
  const yBottom = midY + arrowGap / 2;

  const xLeft = 12.5;
  const xRight = 20;
  const s = arrowHeadSize;

  return (
    <svg
      viewBox="0 0 24 24"
      width={size}
      height={size}
      fill="none"
      stroke="currentColor"
      strokeWidth={strokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
      role="img"
      aria-label={title}
      {...props}
    >
      {title ? <title>{title}</title> : null}

      <path d="m22 16.92v3a2 2 0 0 1-2.18 2 19.8 19.8 0 0 1-8.62-3.07 19.5 19.5 0 0 1-6-6A19.8 19.8 0 0 1 2.08 4.2 2 2 0 0 1 4.06 2h3a2 2 0 0 1 2 1.72c.1.9.3 2 .64 2.72a2 2 0 0 1-.45 2L8.09 9.91a16 16 0 0 0 6 6l1.47-1.47a2 2 0 0 1 2-.45c.72.34 1.82.54 2.72.64A2 2 0 0 1 22 16.92z" />

      <g transform={`translate(${arrowOffsetX},${arrowOffsetY})`}>
        <path d={`M${xLeft} ${yTop} H${xRight}`} />
        <path d={`M${xRight - s} ${yTop - s} L${xRight} ${yTop}`} />
        <path d={`M${xRight - s} ${yTop + s} L${xRight} ${yTop}`} />

        <path d={`M${xRight} ${yBottom} H${xLeft}`} />
        <path d={`M${xLeft + s} ${yBottom - s} L${xLeft} ${yBottom}`} />
        <path d={`M${xLeft + s} ${yBottom + s} L${xLeft} ${yBottom}`} />
      </g>
    </svg>
  );
}
